<template>
  <div class="grid md:grid-cols-3" v-if="employees">
    <div  v-for="employee in employees" :key="employee.id">
      <div class="flex flex-col mx-4 mb-8">
        <img v-if="employee.attributes.Images.data" class="w-full" :src="employee.attributes.Images.data[0].attributes.url || ''" alt="">
        <div>
          <p v-if="employee.attributes.Name">{{ employee.attributes.Name }}</p>
          <p v-if="employee.attributes.Position">{{ employee.attributes.Position }}</p>
          <div v-if="employee.attributes.Beschreibung" class="my-4" v-html="employee.attributes.Beschreibung"></div>
          <div v-if="employee.attributes.Mail">
            <a  class="hover:text-white text-base" :href="'mailto:' + employee.attributes.Mail">E-Mail</a>
          </div>
          <div v-if="employee.attributes.Number">
            <a class="hover:text-white text-base"
               :href="'tel:' + employee.attributes.Number">{{ employee.attributes.Number }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "Employees",
  props: ['employees']
}
</script>

<style scoped>

</style>